import Message from '../src/Message/index.tsx';
export default Message;
